export default __webpack_public_path__ + "static/media/Logo.3c0c8184.png";